import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[hsl(var(--border))] bg-[hsl(var(--muted))]/60">
      <div className="container-cuidar py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <img
            src="/logo-instituto-cuidar.png"
            alt="Instituto Cuidar"
            className="h-14 w-auto object-contain"
          />
          <p className="mt-5 max-w-md text-sm text-[hsl(var(--muted-foreground))]">
            Acolhemos famílias de crianças com TEA, TDAH, dislexia e outras neurodivergências. Informação, comunidade e cuidado — no seu tempo.
          </p>
        </div>
        <div>
          <div className="font-heading font-bold text-sm mb-4">Institucional</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/sobre" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-sobre">Sobre</Link></li>
            <li><Link to="/cursos" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-cursos">Educacional</Link></li>
            <li><Link to="/direitos" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-direitos">Direitos</Link></li>
            <li><Link to="/apoiar" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-apoiar">Apoiar</Link></li>
            <li><Link to="/timeline" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-timeline">Postagens</Link></li>
            <li><Link to="/comunidade" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-comunidade">Comunidade</Link></li>
            <li><Link to="/contato" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-contato">Contato</Link></li>
            <li><Link to="/cadastro" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-cadastro">Cadastrar</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold text-sm mb-4">Fale conosco</div>
          <ul className="space-y-3 text-sm text-[hsl(var(--muted-foreground))]">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0" /> <a href="tel:+5571999687054" className="hover:text-[hsl(var(--primary))]">+55 (71) 99968-7054</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0" /> <a href="mailto:suporteinstitutocuidar@gmail.com" className="hover:text-[hsl(var(--primary))] break-all">suporteinstitutocuidar@gmail.com</a></li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 shrink-0 mt-0.5" /> Av. Estados Unidos, 397 — Salvador, BA</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4 shrink-0" /> @institutocuidar</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[hsl(var(--border))] py-5">
        <div className="container-cuidar flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[hsl(var(--muted-foreground))]">
          <span>© 2021 – {new Date().getFullYear()} Instituto Cuidar — Todos os direitos reservados.</span>
          <span>Feito com cuidado.</span>
        </div>
      </div>
    </footer>
  );
}
